import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'utils/components/tooltip';
import Droplist from 'utils/components/droplist';

const displayName = 'DropDownIcon';

class DropDownIcon extends Component {
  handleMoreClick() {
    this.refs.menuItem.toggle();
    if (this.props.onClick) {
      this.props.onClick();
    }
  }
  hide() {
    this.refs.menuItem.hide();
  }

  render() {
    var { items, icon, caret, children, squeezeBelow } = this.props;
    var className = 'menu-icon';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    let child;
    if (items) {
      child = <Droplist items={items} menuItem={this.refs.menuItem} />;
    } else {
      child = children;
    }

    return (
      <span className={className} ref="menuLabel" onClick={this.handleMoreClick.bind(this)}>
        {icon}
        <Tooltip
          className="dropdown tooltip-general"
          hasScreenBoundries
          renderOutsideContainer
          alignPositionType="absolute"
          horizontalAlign="center"
          caret={caret}
          ref="menuItem"
          alignElement={() => this.refs.menuLabel}
          squeezeBelow={squeezeBelow}
        >
          {child}
        </Tooltip>
      </span>
    );
  }
}

DropDownIcon.defaultProps = {
  squeezeBelow: false
};

DropDownIcon.propTypes = {
  items: PropTypes.array,
  text: PropTypes.string,
  className: PropTypes.string,
  caret: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
  squeezeBelow: PropTypes.bool
};

DropDownIcon.displayName = displayName;

export default DropDownIcon;
